// Generated by psc version 0.10.2
"use strict";
var Control_Category = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Category.purs");
var on = function (f) {
    return function (g) {
        return function (x) {
            return function (y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var flip = function (f) {
    return function (b) {
        return function (a) {
            return f(a)(b);
        };
    };
};
var $$const = function (a) {
    return function (v) {
        return a;
    };
};
var applyFlipped = function (x) {
    return function (f) {
        return f(x);
    };
};
var apply = function (f) {
    return function (x) {
        return f(x);
    };
};
module.exports = {
    apply: apply, 
    applyFlipped: applyFlipped, 
    "const": $$const, 
    flip: flip, 
    on: on
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Function.purs
// module id = 9
// module chunks = 0